import script from "./SeriousQuizPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SeriousQuizPage.vue?vue&type=script&setup=true&lang=js"

import "./SeriousQuizPage.vue?vue&type=style&index=0&id=0fb1db60&lang=scss"
import "./SeriousQuizPage.vue?vue&type=style&index=1&id=0fb1db60&scoped=true&lang=scss"

import exportComponent from "D:\\Dev\\ClimEco\\Django\\ClimEco\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb1db60"]])

export default __exports__